import { FILTRE_TEXTE } from '../utils/rechercheContactConstants'
import { Client } from '../../../types/localStorageModels'
import axios from 'axios'

export const rechercheProspect = (texte: string): Promise<Client[]> => axios(`/api/sitel/contact/recherche?${FILTRE_TEXTE}=${encodeURIComponent(texte)}`)
	.then((response) => response.data)

export const getOffreFromDemande = (contact_id: string) => axios(`/api/sitel/contact/getOffreFromDemande?id_contact=${contact_id}`)
	.then((response) => response.data)